import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import robotIcon from 'assets/img/robot.png'

import apiService from 'apiService'

export default function Login() {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const history = useHistory()

    const handleUsername = e => setUsername(e.target.value)
    const handlePassword = e => setPassword(e.target.value)

    async function submitLogin() {
        const payload = {
            username: username.trim(),
            password: password.trim()
        }
        const authData = await apiService.post('/users/auth', payload)
        if (authData === null) {
            return
        }

        localStorage.setItem(`robot-token`, authData.token)
        const claims = atob(authData.token.split('.')[1])
        localStorage.setItem(`robot-user-data`, claims)
        apiService.refreshAuthHeaders()
        history.push('/admin/dashboard')
    }

    useEffect(() => {
        localStorage.removeItem(`robot-token`)
        localStorage.removeItem(`robot-user-data`)
    }, [])
    return (
        <>
            <div className="container mx-auto px-4 h-full">
                <div className="flex content-center items-center justify-center h-full">
                    <div className="w-full lg:w-4/12 px-4">
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
                            <div className="w-full rounded-t mb-0 px-6 py-6">
                                <img src={robotIcon} style={{ width: '20%', margin: 'auto' }} />
                                <hr className="mt-6 border-b-1 border-blueGray-300" />
                            </div>

                            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                <form>
                                    <div className="relative w-full mb-3">
                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                            ΧΡΗΣΤΗΣ
                                        </label>
                                        <input type="text" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Όνομα Χρήστη" onChange={handleUsername} />
                                    </div>

                                    <div className="relative w-full mb-3">
                                        <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                                            Κωδικος
                                        </label>
                                        <input type="password" className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" placeholder="Κωδικός Πρόσβασης" onChange={handlePassword} />
                                    </div>

                                    <div className="text-center mt-6">
                                        <button className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150" type="button" onClick={submitLogin}>
                                            ΣΥΝΔΕΣΗ
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
